import React from "react";
import Product from "./products";

function page(){
    return(

        <>
        <Product/>
        </>

    );
}
export default page;